export default __webpack_public_path__ + "static/media/qr-code.dfbd88f6.svg";